//https://cdn.jsdelivr.net/npm/simple-parallax-js@6.0.1/dist/vanilla/SimpleParallaxVanilla.umd.min.js
( function ( _s ) {
	/* 
		https://web.dev/articles/intersectionobserver-v2
		Using the InteractionObserver API I can check if a parallax-scene is visible,
		and THEN I load the library and initialize the element. That way I don't load 
		the library on page load while the element is not visible yet. Small optimization.
	*/
	let observedElements = new Set();

	const observeElement = () => {
		const vertParallaxScenes = document.querySelectorAll( '.scroll-parallax-scene' );

		vertParallaxScenes.forEach( scene => {
			if ( scene ) {
				const observer = new IntersectionObserver( entries => {
					if ( entries[ 0 ].isIntersecting && ! observedElements.has( scene ) ) {
						observedElements.add( scene );
						loadLibAndInitialize( scene );
					}
				} );

				observer.observe( scene );
			}
		} );
	};

	const loadLibAndInitialize = vertParallaxScene => {
		if ( window.SimpleParallax !== undefined ) {
			_s( vertParallaxScene ).frVerticalParallaxScene();
		} else {
			window
				.fetchInject( [
					'https://cdn.jsdelivr.net/npm/simple-parallax-js@6.0.1/dist/vanilla/simpleParallaxVanilla.umd.min.js',
				] )
				.then( () => {
					_s( vertParallaxScene ).frVerticalParallaxScene();
				} );
		}
	};

	const getScrollParallaxElementScale = element => {
		let result = null;
		const classes = element.className.split( ' ' );

		classes.forEach( cssClass => {
			if ( cssClass.startsWith( 'scroll-parallax-scene-scale--' ) ) {
				result = cssClass.replace( 'scroll-parallax-scene-scale--', '' );
			}
		} );
		return result;
	};

	const getBreakpointRulesForInitializing = element => {
		let result = {
			desktop: true,
			mobile: true,
		};
		const classes = element.className.split( ' ' );

		classes.forEach( cssClass => {
			if ( cssClass === 'scroll-parallax-scene-breakpoint-desktop-only' ) {
				result = {
					desktop: true,
					mobile: false,
				};
			} else if ( cssClass === 'scroll-parallax-scene-breakpoint-mobile-only' ) {
				result = {
					desktop: false,
					mobile: true,
				};
			}
		} );
		return result;
	};

	const getOverflow = element => {
		let result = null;
		const classes = element.className.split( ' ' );

		classes.forEach( cssClass => {
			if ( cssClass === 'scroll-parallax-scene-overflow' ) {
				result = true;
			}
		} );
		return result;
	};

	const initializeParallax = ( _self, config ) => {
		return new SimpleParallax(
			_self.el[ 0 ].querySelectorAll( ':scope > .scroll-parallax-element' ),
			config
		);
	};

	_s.fn.frVerticalParallaxScene = function () {
		return this.each( el => {
			const _self = _s( el );
			//defaults
			const config = {};
			const scale = getScrollParallaxElementScale( el );
			const overflow = getOverflow( el );
			let instance = false;
			let currentBreakpoint = false;
			const breakpointConfig = getBreakpointRulesForInitializing( el );

			//get config from classes
			if ( scale ) {
				config.scale = parseFloat( scale );
			}
			if ( overflow ) {
				config.overflow = true;
			}

			if ( breakpointConfig.desktop && breakpointConfig.mobile ) {
				//always on, initialize
				instance = initializeParallax( _self, config );
			} else {
				//the breakpoints where the animation should work on
				const enabledBreakpoints = breakpointConfig.desktop
					? [ 'lg', 'xl', 'xxl' ]
					: [ 'xs', 'sm', 'md' ];

				_s( window ).on( 'resize fr:pseudo-resize', e => {
					if ( currentBreakpoint !== window.currentBreakpoint() ) {
						if ( instance ) instance.destroy();

						if ( enabledBreakpoints.includes( window.currentBreakpoint() ) ) {
							instance = initializeParallax( _self, config );
						}

						currentBreakpoint = window.currentBreakpoint();
					}
				} );

				//on page load
				_s( window ).trigger( 'fr:pseudo-resize' );
			}
		} );
	};

	_s( document ).ready( () => {
		observeElement();
	} );
} )( window._s );
